export const ApiServiceOptionsSchema = {
    baseURL: 'https://goodt-dev.goodt.me:8480'
}